import { LiquidiumMode } from '../hooks/useLiquidiumAction'
import { ConnectionProvider } from '../state/connectionProvider'
import { SwapProvider } from './swapInterface'

interface PageView {
  page_title: string
  page_location: string
}

interface SwapEvent {
  type: 'swap' | 'conversion'
  provider: SwapProvider
  from_token: string
  to_token: string
  amount: number
  amount_received: number
}

interface StakeEvent {
  direction: 'stake' | 'unstake'
  amount: number
}

interface BorrowLendEvent {
  direction: LiquidiumMode
  amount: number
}

interface SendTokenEvent {
  token: string
  amount: number
}

interface SendNFTEvent {
  nft: string
}

interface MintEvent {
  token: string
  amount: number
}

interface BridgeOneSecEvent {
  token: string
  amount: number
}

interface OdinEvent {
  amount: number
}

interface CycleTopupEvent {
  amount: number
}

interface CustomTokenAddedEvent {
  standard: string
  address: string
  name: string
}

interface SignInEvent {
  sign_in_method: ConnectionProvider | 'seedphrase' | 'new-wallet'
}

export interface GAUserContext {
  registered: boolean
  first_seen_date: string
  region: string
  locale: string
  language: string
  platform: 'ios' | 'android' | 'extension' | 'web'
  version: string
}

interface WalletCreatedEvent {
  method: 'new-wallet' | 'seedphrase'
}

interface SetupContextEvent {
  entry_point: string
}

interface SetupOptionSelectedEvent {
  method: 'new-wallet' | 'seedphrase'
  entry_point: string
}

interface WalletFundedEvent {
  first_token: string
  usd_value: number
}

export type GAEvent =
  | PageView
  | SwapEvent
  | StakeEvent
  | BorrowLendEvent
  | SendTokenEvent
  | SendNFTEvent
  | MintEvent
  | CycleTopupEvent
  | CustomTokenAddedEvent
  | SignInEvent
  | BridgeOneSecEvent
  | OdinEvent
  | WalletFundedEvent
  | WalletCreatedEvent
  | SetupContextEvent
  | SetupOptionSelectedEvent

export enum GAEventName {
  PAGE_VIEW = 'page_view',
  SWAP = 'swap',
  STAKE = 'stake',
  BORROW_LEND = 'borrow_lend',
  SEND_TOKEN = 'send_token',
  SEND_NFT = 'send_nft',
  MINT = 'mint',
  CYCLE_MINT = 'cycle_mint',
  CYCLE_TOPUP = 'topup',
  DEPOSIT_ODIN = 'deposit_odin',
  WITHDRAW_ODIN = 'withdraw_odin',
  CUSTOM_TOKEN_ADDED = 'custom_token_added',
  BRIDGE_ONESEC = 'bridge_onesec',
  SIGN_IN = 'sign_in',
  WALLET_FUNDED = 'wallet_funded',
  WALLET_CREATED = 'wallet_created',
  WALLET_UNLOCKED = 'wallet_unlocked',
  SETUP_OPENED = 'setup_opened',
  SETUP_OPTION_SELECTED = 'setup_option_selected',
  SETUP_FULLSCREEN_REDIRECT = 'setup_fullscreen_redirect',
  WALLET_IMPORT_FAILED = 'wallet_import_failed',
  PLUG_SESSION_START = 'plug_session_start',
}
